import { render, staticRenderFns } from "./AddComponent.vue?vue&type=template&id=1a103564&"
import script from "./AddComponent.vue?vue&type=script&lang=js&"
export * from "./AddComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports